module.exports = __webpack_public_path__ + "img/2.fbf7b449.gif";